const preferredPartsFields = [
  // {
  //   field: 'commands',
  //   title: 'Actions',
  //   cell: 'commands',
  //   sortable: false,
  //   locked: true,
  //   width: 60,
  //   hidden: false,
  // },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    field: 'partNumber',
    title: 'Part Number',
    sortable: false,
    hidden: false,
  },
  {
    field: 'statusName',
    title: 'Status',
    sortable: false,
    hidden: false,
  },
  {
    field: 'customerPN',
    title: 'Customer PN',
    sortable: false,
    hidden: false,
  },
  {
    field: 'required',
    cell: 'formatSeparator',
    title: 'Required',
    sortable: false,
    hidden: false,
  },
  {
    field: 'cost',
    title: 'Cost',
    cell: 'formatAmount',
    sortable: false,
    hidden: false,
  },
  {
    field: 'mfgName',
    title: 'Mfr',
    sortable: false,
    hidden: false,
  },
  {
    field: 'dateCode',
    title: 'Date Code',
    sortable: false,
    hidden: false,
  },
  {
    field: 'conditionName',
    title: 'Condition',
    sortable: false,
    hidden: false,
  },
]

export default preferredPartsFields;
